<template>
    <span>
        <a-select size="small" :placeholder="$t('search.selectDeviceModel')" v-model="option.value" :allowClear="option.allowClear" @change="handleChange">
             <a-select-option v-for="model in models" :key="model.id" :value="model.id">{{model.name}}</a-select-option>
        </a-select>
    </span>
</template>

<script>
    import config from '@/config'

    export default {
        name: "deviceTypeChooser",
        props: ["option"],
        data: function () {
            return {
                models:[]
            }
        },
        created() {
            this.initTypes();
        },
        methods: {
            initTypes(){
                let _this = this
                this.$http.get(config.api.device_types_url).then((response) => {
                    _this.models = response.result
                    // console.log(response)
                    if(!this.option.allowClear && _this.models ){
                        this.option.value = _this.models[0].id
                        this.option.modelName = this.models[0].name
                    }
                })
            },
            setDefault(){
                if(!this.option.allowClear && this.models){
                    this.option.value = this.models[0].id
                    this.option.modelName = this.models[0].name
                }else{
                    this.option.value = null
                    this.option.modelName = null
                }
            },
            handleChange(value) {
                // let _this = this
                value && this.models.map((item) => {
                    if(item.id == value){
                        this.option.modelName = item.name
                        this.$emit('deviceModelChange',item)
                    }
                })
                !value && this.$emit('deviceModelChange')
            }
        }
    }
</script>